// extracted by mini-css-extract-plugin
export default {"container":"gkriEclmpBrJv4WpM8Tw","infoIcon":"utIQatOSmIWk2L4TCj_h","content":"z3oe3uipk2v_ohhrmoxY","title":"KBPNS8Y8HCcuQw8WuBWZ","description":"aYuHyaE8Nrr1IvZlyenn"};